import React from "react";
import AwardDetailTable from "./AwardDetailTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const AwardDetailIndex = () => (
  <ReportProgramsPage
    TableComponent={AwardDetailTable}
    loadingMessage="Loading award detail..."
  />
);

export default AwardDetailIndex;
